module.exports = __webpack_public_path__ + "img/main-image.4473368c.jpg";